import React from 'react';
import glamorous from 'glamorous';
import {ASH, FOCUS_BLUE, WHITE} from '../../../../shared/style/colors';
import {Heading} from '../../../feed/components/heading/shared';
import {PHONE} from '../../../../shared/style/breakpoints';

const Banner = glamorous.div({
  width: '100%',
  height: 200,
  display: 'flex',
  backgroundSize: 'cover',
  backgroundColor: FOCUS_BLUE,
  backgroundImage:
    'url(https://stackshare.io/assets/updated-blue-tile-pattern-90b2a30555d845a7e7c4d529f8c3c14c3693ea5ad00fd4ed1116614c561b39d4.svg)'
});

const Content = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  textAlign: 'center'
});

const StyledHeading = glamorous(Heading)({
  color: WHITE,
  fontSize: '40px',
  lineHeight: '50px',
  marginBottom: 15,
  [PHONE]: {
    fontSize: '35px',
    marginBottom: 10
  }
});

const Link = glamorous.a({
  color: WHITE,
  fontSize: '18px',
  ' &:hover': {
    color: ASH
  },
  [PHONE]: {
    fontSize: '16px'
  }
});

const Header = () => {
  return (
    <Banner>
      <Content>
        <div>
          <StyledHeading>Companies To Follow</StyledHeading>
          <Link href="https://stackshare.io/posts/introducing-new-company-engineering-profiles">
            Read more about new Company Profiles
          </Link>
        </div>
      </Content>
    </Banner>
  );
};
export default Header;
